/** Ai 角色列表 — 列宽按内容量级权重比例分配（与 linkTableLayout 同算法）。 */

export const AI_ASSISTANT_TABLE_COLUMN_WEIGHTS = {
  selection: 44,
  name: 118,
  roleName: 120,
  avatar: 88,
  category: 150,
  lock: 180,
  status: 102,
  time: 150,
  // 四钮（查看/编辑/复制/删除）需同行不折行。通用资源列表的 action 权重单独加宽。
  action: 260,
}

const COLUMN_KEYS = Object.keys(AI_ASSISTANT_TABLE_COLUMN_WEIGHTS)
const WEIGHT_SUM = Object.values(AI_ASSISTANT_TABLE_COLUMN_WEIGHTS).reduce(
  (sum, value) => sum + value,
  0
)

export const AI_ASSISTANT_TABLE_FALLBACK_WIDTH = WEIGHT_SUM

export function computeAiAssistantTableColumnWidths(containerWidth) {
  const raw = Math.floor(Number(containerWidth) || 0)
  const width = raw > 0 ? raw : AI_ASSISTANT_TABLE_FALLBACK_WIDTH
  const result = {}
  let assigned = 0

  COLUMN_KEYS.forEach((key, index) => {
    if (index === COLUMN_KEYS.length - 1) {
      result[key] = width - assigned
      return
    }
    const slice = Math.floor((width * AI_ASSISTANT_TABLE_COLUMN_WEIGHTS[key]) / WEIGHT_SUM)
    result[key] = slice
    assigned += slice
  })

  return result
}
